import { render, staticRenderFns } from "./FleetManagement.vue?vue&type=template&id=4f8a7bfe&"
import script from "./FleetManagement.vue?vue&type=script&lang=js&"
export * from "./FleetManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports